import React from 'react';
import { ToggleButton, ToggleButtonProps } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { buttonBackgroundSelector } from '../redux/selectors/buttonBackground.selector';

export const FiltersButton = (props: ToggleButtonProps) => {
  const buttonBackgroundClass = useSelector(buttonBackgroundSelector);
  return (
    <ToggleButton
      {...props}
      className={`mr-3 px-3 rounded text-uppercase ${
        props.variant === 'info' ? buttonBackgroundClass : buttonBackgroundClass ? 'button-black-background' : ''
      }`}
      size='sm'>
      {props.children}
    </ToggleButton>
  );
};
